var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isAssessment)?_c('AssessmentHighlight'):(_vm.isCosPlusSw)?_c('CosPlusSwHighlight'):(_vm.isSw)?_c('SwHighlight'):(_vm.isDependant)?_c('DependantHighlight'):_c('PaidServicesHighlight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }